module.exports = __webpack_public_path__ + "img/blister.5d006e3f.png";